// extracted by mini-css-extract-plugin
module.exports = {"card":"section3_card__OwW9_","primaryColor":"section3_primaryColor__a973r","button":"section3_button__ma8iz","section3":"section3_section3__EDqya"};